import React, { useEffect, useState } from 'react'
import { LeftSide, StructureListItem, StructuresListContainer, Title } from '../../CreateCertificate/style'
import axios from 'axios'
import { ParamType, StructureType } from '..'
import { EllipsisVertical } from 'lucide-react'
import OptionsDropdown from './OptionsDropdown'

interface PropsType {
  setParam: React.Dispatch<React.SetStateAction<ParamType>>
  param: ParamType
}

const ManageStructures:React.FC<PropsType> = ({setParam, param}) => {
  const [ viewDropdownOptions, setViewDropdownOptions ] = useState<number | null>(null)
  const [ structures, setStructures ] = useState<StructureType[]>([])
  
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_CERTIFICATES_BASE_URL}/structure`)
      .then((response) => {
        if(response.data) setStructures(response.data)
        return
      })
      .catch((error) => {
        console.error(error)
      })
  }, [])

  const handleAddStructure = (structure:StructureType) => {
    setParam(prev => ({
      ...prev,
      structures: [...prev.structures, structure]
    }))
  }
  
  return (
    <LeftSide>
      <Title>Estruturas</Title>
      <StructuresListContainer>
        {structures.map((structure, index) => (
          <StructureListItem last={index === structures.length - 1} key={index}>
            {structure.name}
            {param.structures.find((item) => item.id === structure.id) ?
            <span>
              <EllipsisVertical 
                size={18} 
                style={{cursor: 'pointer', color: '#696969'}} 
                onClick={() => setViewDropdownOptions(index)}
              />
            </span>
              :
              <span onClick={() => handleAddStructure(structure)}>+</span>
            }
            {viewDropdownOptions === index && <OptionsDropdown 
              onClose={() => setViewDropdownOptions(null)} 
              setParam={setParam}
              structure={structure}
            />}
          </StructureListItem>
        ))}
      </StructuresListContainer>
    </LeftSide>
  )
}

export default ManageStructures